import { createSelector } from 'reselect'

export const getFavouriteSoldAdsLoading = createSelector(
  state => state && state.user && state.user.profile
    && state.user.profile.favouriteAds
  ? state.user.profile.favouriteAds.Sold.isLoading : false,
 	isLoading => isLoading
)
